import I18n from 'I18n';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { MALFORMED_EMAIL, PREVIOUSLY_BOUNCED, MISSING_PERMISSION } from 'composer-data/email/public/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getToolTipString = (identifierValue, validationData, isEmailLoggingBlocked) => {
  if (validationData && !validationData.isValid) {
    if (validationData.reason === MALFORMED_EMAIL) {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.invalid-email', {
        recipientEmail: identifierValue
      });
    } else if (validationData.reason === PREVIOUSLY_BOUNCED) {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.bounced-contact', {
        recipientEmail: identifierValue
      });
    } else if (validationData.reason === MISSING_PERMISSION) {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.permissions', {
        recipientEmail: identifierValue
      });
    } else if (validationData.reason === 'WHATSAPP_NOT_OPTED_IN') {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.whatsapp-subscription');
    }
  } else if (isEmailLoggingBlocked) {
    return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.never-log', {
      recipientEmail: identifierValue
    });
  }
  return identifierValue;
};
const GenericRecipientTag = ({
  option: {
    name,
    address,
    value,
    validationData,
    isEmailLoggingBlocked
  }
}) => {
  const tagTextContent = name || address || value;
  const isInvalid = validationData && !validationData.isValid;
  return /*#__PURE__*/_jsx(UITooltip, {
    style: {
      display: 'inline-block'
    },
    title: getToolTipString(address || value, validationData, isEmailLoggingBlocked),
    children: /*#__PURE__*/_jsxs("span", {
      children: [tagTextContent, isInvalid || isEmailLoggingBlocked ? /*#__PURE__*/_jsx(UIIcon, {
        name: isEmailLoggingBlocked ? 'info' : 'warning',
        className: "m-left-1",
        size: "xxs"
      }) : null]
    })
  });
};
GenericRecipientTag.displayName = 'GenericRecipientTag';
export default GenericRecipientTag;